import React, { forwardRef } from 'react';

import { DEFAULT_ELEMENT_TYPE } from './CocoSharpText.constants';
import {
  StyledCocoSharpInput,
  StyledCocoSharpText,
} from './CocoSharpText.styles';
import { Props } from './CocoSharpText.types';

export const CocoSharpText = forwardRef<
  HTMLElement,
  Props & React.HTMLAttributes<HTMLElement>
>(({ elementType = DEFAULT_ELEMENT_TYPE, children, ...props }, ref) => {
  const Component = StyledCocoSharpText.withComponent(elementType);
  return (
    <Component ref={ref} {...props}>
      {children}
    </Component>
  );
});

CocoSharpText.displayName = 'CocoSharpText';

export const CocoSharpInput = forwardRef<
  HTMLInputElement,
  Omit<Props, 'elementType'> & {
    error?: string | boolean;
  } & React.InputHTMLAttributes<HTMLInputElement>
>(({ children, desktopSize, mobileSize = 'md', ...props }, ref) => {
  // if input font size is < 16px, it will cause zooming in mobile browsers like Safari
  const inputMobileSize =
    mobileSize === 'xs' || mobileSize === 'sm' ? 'md' : mobileSize;
  const inputDesktopSize = desktopSize ?? mobileSize;

  return (
    <StyledCocoSharpInput
      mobileSize={inputMobileSize}
      desktopSize={inputDesktopSize}
      ref={ref as React.Ref<HTMLInputElement>}
      {...props}
    >
      {children}
    </StyledCocoSharpInput>
  );
});

CocoSharpInput.displayName = 'CocoSharpInput';
